import React from "react";
import BasicView from "../../Templates/BasicView";
import ColComponent from "../../Templates/ColComponent";
import CardComponent from "../../Templates/CardComponent";
import ConsultaGeneralMainView from "./ConsultaGeneralMainView";

export default function ConsultaGinecologiaMainView(props) {
  return <ConsultaGeneralMainView {...props} />;
}
